import React, { ComponentType } from 'react'

import { UserPanel } from 'src/layout/header/UserPanel'
import { View } from 'src/ui/basic/View'
import { useTran } from 'src/i18n/useTran'
import { NavLink } from 'src/layout/header/NavLink'
import { useTheme } from 'src/ui/style/useTheme'
import { LanguageSwitcher } from 'src/layout/header/LanguageSwitcher'
import {
    horizontalChildSpacing,
    horizontalLayout
} from 'src/ui/style/mixins/layout'
import { pages } from 'src/routing/pages'
import { msg } from 'src/i18n/texts/keys'
import { useChooseWarehouseLink } from 'src/business/landing-page/link/useChooseWarehouseLink'
import { useSearchParams } from 'src/app/useSearchParams'

const pageNavItems: [string, string][] = [
    [msg.ui.nav.items.home, pages.Landing.to()],
    [msg.ui.nav.items.boxes, useChooseWarehouseLink()],
    ...(process.env.SPA_SHOW_SHIPMENTS_NAV === 'true'
        ? [[msg.ui.nav.items.shipments, pages.Shipments.to()] as [string, string]]
        : []),
    [msg.ui.nav.items.help, pages.Help.to()]
]

export const DesktopNavigation: ComponentType = () => {
    const t = useTran()
    const th = useTheme()
    const limitedView = useSearchParams().get('limitedView') === 'true'
    if (limitedView) return null

    return (
        <View
            horizontal
            css={horizontalLayout({
                spacing: th.spacing.lg,
                breakpoint: '1030px',
                breakpointSpacing: th.spacing.md
            })}
        >
            {pageNavItems?.map(([label, to], i) => (
                <NavLink key={label} to={to}>
                    {t(label)}
                </NavLink>
            ))}
            <View horizontal css={[horizontalChildSpacing(th.spacing.md)]}>
                <UserPanel />
                <LanguageSwitcher />
            </View>
        </View>
    )
}
